export default __webpack_public_path__ + "516204c.png";